import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-deleted-clients',
  templateUrl: './deleted-clients.page.html',
})
export class DeletedClientsPage implements OnInit {

  clients: any[] = null;
  loaded = false;
  any_restored = false;

  constructor(
    private apiService: ApiService,
    private modalController: ModalController,
    private alertController: AlertController,
    public globalService: GlobalService
  ) {}

  ngOnInit() {
    this.LoadData();
  }

  async LoadData() {
    this.loaded = false;
    const data: any = await this.apiService.get('clients?show_deleted=1');
    this.clients = data.success ? (data.data || []) : [];
    this.loaded = true;
  }

  async RestoreClient(client: any) {
    const alert = await this.alertController.create({
      header: 'Restore Contact',
      message: `Are you sure you want to restore <strong>${client.display_name}</strong>? This will also restore any projects, tasks, and steps that were deleted at the same time.`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Restore',
          handler: async () => {
            await this.globalService.presentLoading('Restoring contact...', 9000000);
            const data: any = await this.apiService.put(`clients/${client.guid}/restore`, {});
            this.globalService.dismissLoading();
            if (data.success) {
              this.globalService.presentToastMessage(data.message, true);
              this.clients = this.clients.filter(c => c.guid !== client.guid);
              this.any_restored = true;
            } else {
              this.globalService.presentToastMessage(data.message, false);
            }
          }
        }
      ]
    });
    await alert.present();
  }

  Close() {
    this.modalController.dismiss({ restored: this.any_restored });
  }
    ToLocalDate(utcString: string): Date | null {
    if (!utcString) return null;
    const s = utcString.endsWith('Z') || /[+\-]\d{2}:?\d{2}$/.test(utcString) ? utcString : utcString + 'Z';
    return new Date(s);
  }
}



